import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import ShareBarBase from './ShareBarBase';

export default class LinkedInShare extends ShareBarBase {
  static propTypes = {
    shareBarStyles: PropTypes.object,
    url: PropTypes.string.isRequired,
    widgetId: PropTypes.string,
    additionalURLParams: PropTypes.array,
    hideLinkedInOnIEAndEdge: PropTypes.bool
  };
  static defaultProps = {
    additionalURLParams: []
  };

  componentDidMount() {
    super.componentDidMount();
    if (typeof this.window.IN === 'undefined') {
      // Adding the script to the page to embed LinkedIn Share Button when this widget gets mounted on the DOM
      if (this.window.document.getElementById('linkedin-wjs')) {return;}
      const linkedInScript = this.window.document.createElement('script');
      linkedInScript.src = 'https://platform.linkedin.com/in.js';
      linkedInScript.async = true;
      linkedInScript.id = 'linkedin-wjs';
      this.window.document.body.appendChild(linkedInScript);
    } else {
      // Re-loading the Share Button when the widget gets re-mounted with existing button in it
      this.window.IN.parse();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customizeWidgetData && this.props.customizeWidgetData &&
      prevProps.customizeWidgetData.displayLinkedIn !== this.props.customizeWidgetData.displayLinkedIn) {
      // Re-loading the button when display property is updated by the user
      if (typeof this.window.IN !== 'undefined') {
        this.window.IN.parse();
      }
    }
  }

  render() {
    const {
      shareBarStyles,
      url,
      additionalURLParams,
      hideLinkedInOnIEAndEdge,
      widgetId
    } = this.props;

    const updatedURL = this.addQueryParamsToURL(url, additionalURLParams);
    const containerId = `linkedin-${widgetId}`;
    const scriptId = `linkedin-script-${widgetId}`;

    return (
      <div
        {...resolve(shareBarStyles, 'wrapper', 'linkedInContainer',
          hideLinkedInOnIEAndEdge ? 'linkedInOnIEAndEdge' : '')
        }
        id={containerId}
      >
        <script
          id={scriptId}
          type="IN/Share"
          data-url={updatedURL}
        ></script>
      </div>
    );
  }
}
